import { render, staticRenderFns } from "./HandleClient.vue?vue&type=template&id=61a2f099&"
import script from "./HandleClient.vue?vue&type=script&lang=js&"
export * from "./HandleClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports